import { Button, Stack, type Theme } from "@mui/material";
import type { Dispatch, FC, SetStateAction } from "react";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import {
	type ChartTimeFrameKey,
	ChartTimeFrames,
} from "web_myplann/Utils/types";

type Props = {
	timeFrame: ChartTimeFrameKey;
	setTimeFrame: Dispatch<SetStateAction<ChartTimeFrameKey>>;
};

export const DataLineChartButtons: FC<Props> = ({
	timeFrame,
	setTimeFrame,
}) => {
	const { t } = useResource();

	const buttonSx = {
		width: 36,
		minWidth: 36,
		height: 24,
		borderRadius: 28,
		border: "none",
		fontSize: 12,
		fontWeight: 500,
		color: (theme: Theme) => theme.palette.myPLANN.main,
	};

	return (
		<Stack direction="row" justifyContent={"space-between"} paddingInline={2}>
			{Object.entries(ChartTimeFrames).map(([key, label]) => {
				const buttonTimeFrame = Number(key) as ChartTimeFrameKey;
				const isActive = timeFrame === buttonTimeFrame;

				return (
					<Button
						key={key}
						onClick={() => setTimeFrame(buttonTimeFrame)}
						variant={isActive ? "contained" : "outlined"}
						color="primary"
						sx={{
							...buttonSx,
							...(isActive && {
								backgroundColor: (theme: Theme) => theme.palette.myPLANN.main,
								color: (theme: Theme) => theme.palette.darkmodeText.white,
							}),
						}}
					>
						{t(label)}
					</Button>
				);
			})}
		</Stack>
	);
};
